<template>
  <div class="how-active">
    <div class="ha-des">
      <p class="black">问：我家里有两个孩子，但买的两套课程都激活在一个手机号上了，两个孩子怎么做各自的作业呢？</p>
      <p>答：进入可瀚学堂APP的“帮助”页面，通过添加客服微信或拨打客服电话联系我们。说明您的需求，核实情况后，我们可以将您的课程分别激活在两个手机上。</p>

    </div>
    <Card></Card>
    <!-- <div class="ha-img">
      <img src="./img/twochild.png" alt="">
    </div> -->
    <div class="ha-des">
       <p class="black">问：我家里有两个孩子，但家里现在只有一个手机，平时还不一定在家，怎么做作业呢？</p>
       <p>答：您可以在一个孩子完成作业后退出账号，登录另一个孩子的账号，让他学习和完成作业。可瀚学堂也可以安装在安卓和苹果的平板上给孩子使用。您家里有电脑的话，也可以在电脑上安装逍遥安卓模拟器(模拟器下载地址http:www.xyaz.cn/)然后在模拟器中，安装可瀚学堂APP (下载地址：http://a.app.qq.com/o/simple.jsp?pkgname=com.kehigh.student）请您注意，在电脑上进行跟读、背诵、配音时，需要您有一个带麦克风的耳机。</p>
    </div>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
  @import '../../../src/assets/css/basic.scss';

  .how-active {
    padding: 0 p2r(20);
    width: 100%;
    .ha-des {
      padding: p2r(15) 0;
      font-size: p2r(15);
      color: $a77;
      p {
        margin: p2r(10) 0;
      }
      a {
        color: $blue;
      }
    }
    .ha-img {
      width: 100%;
      img {
        width: 100%;
      }
    }
  }
</style>
<script>
  import Card from '../../components/Card'
  export default{
    data(){
      return {
        msg: 'hello vue'
      }
    },
    created(){
      document.title = "其他问题? 可瀚学堂-深圳市格熙信息科技有限公司"
      this.$sendAnalytics('点击家里有两个孩子怎么办问题')
    },
    components: {Card}
  }
</script>
